/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
/*! B2XCORE - Profile Library version: 2.104.0 */
var a = /* @__PURE__ */ ((B) => (B.CT = "ct", B.CTX = "ctx", B))(a || {}), r = /* @__PURE__ */ ((B) => (B.B2B = "B2B", B.B2C = "B2C", B))(r || {}), C = /* @__PURE__ */ ((B) => (B.URL = "url", B.PAGE = "page", B.PERSISTED = "persisted", B.USER = "user", B.PAL = "pal", B))(C || {}), A = /* @__PURE__ */ ((B) => (B.B2C_DEFAULT = "B2C_DEFAULT", B.B2B_DEFAULT = "B2B_DEFAULT", B))(A || {}), E = /* @__PURE__ */ ((B) => (B.B2B = "B2B", B.B2C = "B2C", B))(E || {}), L = /* @__PURE__ */ ((B) => (B.BIAS = "BIAS", B.CIAS = "CIAS", B))(L || {});
export {
  r as B,
  E as C,
  L as I,
  C as P,
  a as Q,
  A as a
};
